import { TaskListItem } from '@myapp/contract'
import { Clock, ChevronRight } from 'lucide-react'

interface Props {
  tasks: TaskListItem[]
  onTaskClick: (taskId: number) => void
}

function formatDeadline(iso: string): string {
  const d = new Date(iso)
  return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export const UnscheduledTasksBanner = ({ tasks, onTaskClick }: Props) => {
  if (tasks.length === 0) return null

  return (
    <div className="flex flex-col gap-1.5 px-3 py-2 bg-red-50/50 border-b border-red-100">
      {/*
        The count is here because the widget caps how tall this whole notice area may grow on a
        phone. Once the list scrolls inside that cap, the number is the only thing that says how
        much is below the fold.
      */}
      <span className="text-[11px] font-medium text-red-400 uppercase tracking-wide">
        Offene Aufgaben
        {tasks.length > 1 && <span className="ml-1 tabular-nums">({tasks.length})</span>}
      </span>
      {tasks.map((task) => (
        <button
          key={task.id}
          type="button"
          className="flex w-full min-h-[44px] items-center gap-2.5 bg-white rounded-lg shadow-sm border border-red-200 border-l-4 px-3 py-2 text-left hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 select-none"
          style={{ borderLeftColor: '#D96868' }}
          onClick={() => onTaskClick(task.id)}
        >
          <Clock size={15} color="#D96868" className="shrink-0" />
          {/* Spans, not divs and paragraphs: a <button> may only contain phrasing content. */}
          <span className="flex-1 min-w-0 block">
            <span className="block text-sm font-semibold text-gray-800 truncate leading-tight">
              {task.title}
            </span>
            {task.deadline && (
              <span className="block text-xs text-gray-500 leading-tight mt-0.5">
                bis {formatDeadline(task.deadline)}
              </span>
            )}
          </span>
          <ChevronRight size={15} className="shrink-0 text-gray-400" />
        </button>
      ))}
    </div>
  )
}
